<footer class="footer">
  <div class="kota-container">
    <div class="footer__top">
      <div class="footer__brand">
        <a routerLink="/" class="footer__logo">
          <img src="assets/img/kota_logo.png" alt="KOTA" class="footer__logo-img" />
        </a>
        <p class="footer__desc">
          Transformamos espacios en santuarios de confort y elegancia.
        </p>
        <div class="footer__social">
          <a href="#" class="footer__social-link" aria-label="Facebook" (click)="noopClick($event)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
            </svg>
          </a>
          <a href="#" class="footer__social-link" aria-label="Instagram" (click)="noopClick($event)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
            </svg>
          </a>
          <a href="#" class="footer__social-link" aria-label="Twitter" (click)="noopClick($event)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
              />
            </svg>
          </a>
        </div>
      </div>

      <div class="footer__cols">
        <div class="footer__col">
          <h4 class="footer__col-title">Tienda</h4>
          <ul class="footer__list">
            <li><a routerLink="/catalogo">Recámaras</a></li>
            <li><a routerLink="/catalogo">Muebles</a></li>
            <li><a routerLink="/catalogo">Ofertas</a></li>
          </ul>
        </div>
        <div class="footer__col">
          <h4 class="footer__col-title">Empresa</h4>
          <ul class="footer__list">
            <li><a routerLink="/nosotros">Nosotros</a></li>
            <li><a href="#" (click)="noopClick($event)">Contacto</a></li>
            <li><a href="#" (click)="noopClick($event)">Blog</a></li>
          </ul>
        </div>
        <div class="footer__col">
          <h4 class="footer__col-title">Ayuda</h4>
          <ul class="footer__list">
            <li><a href="#" (click)="noopClick($event)">FAQ</a></li>
            <li><a href="#" (click)="noopClick($event)">Envíos</a></li>
            <li><a href="#" (click)="noopClick($event)">Devoluciones</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer__bottom">
      <p class="footer__copy">© 2026 KOTA. Todos los derechos reservados.</p>
      <div class="footer__legal">
        <a href="#" (click)="noopClick($event)">Privacidad</a>
        <a routerLink="/terminos">Términos</a>
      </div>
    </div>
  </div>
</footer>
